import { useState, useEffect } from 'react';
import type { FC, ReactNode } from 'react';
import { BsQuestionCircle } from 'react-icons/bs';
import { IoClose } from 'react-icons/io5';

import styles from './JoTooltip.module.css';

type Props = {
  trigger?: string | ReactNode;
  text: string | ReactNode;
  buttonText?: string | ReactNode;
};

const JoTooltip: FC<Props> = ({
  trigger = <BsQuestionCircle size={12} />,
  text,
  buttonText = <IoClose size={16} />,
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  useEffect(() => {
    if (!isTooltipOpen) return;
    const handleClickOutside = (event: MouseEvent) => {
      const openTooltip = document.querySelector(`.${styles.tooltip}`);
      if (openTooltip && !openTooltip.contains(event.target as Node)) {
        setIsTooltipOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    // eslint-disable-next-line consistent-return
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isTooltipOpen]);

  const handleCloseTooltip = () => {
    setIsTooltipOpen(false);
  };

  return (
    <>
      <button className={styles.tooltipTrigger} type="button" onClick={() => setIsTooltipOpen(!isTooltipOpen)}>
        {trigger}
      </button>
      {isTooltipOpen && (
        <div className={styles.tooltip}>
          <button type="button" className={styles.tooltipCloseButton} onClick={handleCloseTooltip}>
            {buttonText}
          </button>
          <div className={styles.tooltipContent}>{text}</div>
        </div>
      )}
    </>
  );
};

export default JoTooltip;
